export const environment = {
  production: false,
  APP_ID: '1ea1028a-1da4-42ea-a803-abc4a2b008b0',
  API_BASE_URL: 'https://promo-ecs.useast1.dev.arv.aws.ual.com/offers/api/acceleratorpromo',
  IMAGE_BASE_URL: 'https://promo-ecs.useast1.dev.arv.aws.ual.com/chaseacceleratorpromo/public/images/',
  ASSETS_BASE_URL: 'https://promo-ecs.useast1.dev.arv.aws.ual.com/assets/img/',
};
